import React, { Fragment, useState, useRef, useEffect } from 'react';

import Language from './Language';
import Searchbar from './Searchbar';
import Notificationbar from './Notificationbar';
import MoonLight from './MoonLight';
import CartHeader from './CartHeader';
import BookmarkHeader from './BookmarkHeader';
import UserHeader from './UserHeader';
import { UL } from '../../../AbstractElements';
import { Col } from 'reactstrap';
import FullScreenToggle from './FullScreenToggle';
import { Link } from 'react-router-dom';
import { useCollection } from '../../../_helper/dailyCollection';
import { useCurrency } from '../../../_helper/currencyContext';
import { useLab } from '../../../_helper/PharmacyProvider';
import { Info } from 'lucide-react';

const RightHeader = () => {
  const { daily } = useCollection();
  const { getCurrencySymbol } = useCurrency();
  const { currentLab } = useLab();

  const [showAll, setShowAll] = useState(false);
  const dropdownRef = useRef(null);

  const baseCurrency = currentLab?.baseCurrency || 'INR';

  // ✅ Safe collection getter
  const getCollectionAmount = (currency) => {
    if (!daily || Object.keys(daily).length === 0) {
      return 0;
    }
    return Number(daily[currency] || 0);
  };

  // ✅ Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowAll(false);
      }
    };

    if (showAll) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showAll]);

  return (
    <Fragment>
      <Col
        xxl="7"
        xl="7"
        md="7"
        className="p-0 nav-right pull-right right-header col-8 ms-auto"
      >
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
          <div className="d-flex align-items-center gap-2 position-relative">
            <span className="fw-bold">
              Today's Collection:
            </span>

            {/* ✅ Base currency total */}
            {/* <span className="fw-bold">
              {getCurrencySymbol(baseCurrency)}
              {getCollectionAmount(baseCurrency).toFixed(2)}
            </span> */}

            {/* Info icon */}
            <Info
              size={18}
              className="tw-cursor-pointer hover:text-primary"
              onClick={() => setShowAll(!showAll)}
            />

            {/* Dropdown */}
            {showAll && (
              <div
                ref={dropdownRef}
                className="position-absolute bg-white shadow text-secondary rounded p-3 mt-2"
                style={{
                  top: '100%',
                  right: 0,
                  zIndex: 1000,
                  minWidth: '220px',
                  border: '1px solid #ddd',
                }}
              >
                {Object.keys(daily || {}).length === 0 ? (
                  <div className="text-center fw-bold">
                    {getCurrencySymbol(baseCurrency)}0.00
                  </div>
                ) : (
                  Object.keys(daily).map((currency) => (
                    <div
                      key={currency}
                      className="d-flex justify-content-between py-1"
                    >
                      <span>{currency}</span>
                      <strong>
                        {getCurrencySymbol(currency)}
                        {Number(daily[currency] || 0).toFixed(2)}
                      </strong>
                    </div>
                  ))
                )}

                <div
                  className="text-end mt-3 text-primary cursor-pointer"
                  onClick={() => setShowAll(false)}
                >
                  Close
                </div>
              </div>
            )}
          </div>

          <UserHeader />
        </UL>
      </Col>
    </Fragment>
  );
};

export default RightHeader;
